import { render } from "./editRebus.vue?vue&type=template&id=4d5d20e0&scoped=true"
import script from "./editRebus.vue?vue&type=script&lang=js"
export * from "./editRebus.vue?vue&type=script&lang=js"

import "./editRebus.vue?vue&type=style&index=0&id=4d5d20e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d20e0"]])

export default __exports__